module.exports = __webpack_public_path__ + "static/draining-585339058816b324cbec92e446d1a681.svg";